import { all } from 'redux-saga/effects'
import homeSaga from './home/saga'
import authSaga from './auth/saga'
import organizationSaga from './organization/saga'
import userSaga from './user/saga'
import eventSaga from './event/saga'
import objectSaga from './object/saga'
import qbmediaSaga from './qbmedia/saga'
import taskSaga from './task/saga'
import qbroleSaga from './qbrole/saga'
import ReportSaga from './report/saga'
import scrumBoardSaga from './scrumBoard/saga'
import notifySaga from './Notify/saga'
// component saga
import ComponentSelectMediaSaga from './component_select_media/saga'
import ComponentSelectObjectSaga from './component_select_object/saga'
import ComponentSelectEventSaga from './component_select_event/saga'
import CompoentnSelectReportSaga from './component_select_report/saga'
import quickMessageSaga from './quickMessage/saga'
import chartSaga from './chart/saga'
export default function* rootSaga() {
    yield all([
        homeSaga(),
        authSaga(),
        organizationSaga(),
        userSaga(),
        eventSaga(),
        objectSaga(),
        qbmediaSaga(),
        taskSaga(),
        qbroleSaga(),
        ReportSaga(),
        scrumBoardSaga(),
        ComponentSelectMediaSaga(),
        ComponentSelectObjectSaga(),
        ComponentSelectEventSaga(),
        CompoentnSelectReportSaga(),
        notifySaga(),
        chartSaga(),
        quickMessageSaga(),
    ])
}
